import * as React from "react";
import Button, { type ButtonProps } from "../component";

export type AsyncButtonProps = ButtonProps & {
  action: (e: React.MouseEvent) => Promise<any> | void;
  progressText?: string;
};

interface State {
  isInProgress: boolean;
}

class AsyncButton extends React.Component<AsyncButtonProps, State> {
  public static defaultProps = {
    progressText: "Please wait..."
  };

  public state = {
    isInProgress: false
  };

  public render() {
    const { action, progressText, children, onClick, ...props } = this.props;
    const { isInProgress } = this.state;

    return (
      <Button {...props} isDisabled={isInProgress} onClick={this._onClick}>
        {isInProgress ? progressText : children}
      </Button>
    );
  }

  private _onClick = (e: React.MouseEvent) => {
    if (this.state.isInProgress) return;

    const pp = this.props.action(e);
    if (pp instanceof Promise) {
      this.setState({ isInProgress: true });

      pp.then(
        () => this.setState({ isInProgress: false }),
        () => this.setState({ isInProgress: false })
      );
    }
  };
}

export default AsyncButton;
